import { createSlice } from '@reduxjs/toolkit';
import { IOrder } from '../../../../dto';
import { setOrder } from '../actions';
import { MN_ORDERS, TYPE_ELEMENT } from '../../../../common';

export interface OrderState {
  data: IOrder | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrderState = {
  data: null,
  loading: false,
  error: null,
};

export const orderSlice = createSlice({
  name: `${MN_ORDERS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setOrder, (state, { payload }) => {
      state.data = payload;
    });
  },
});
